import React, { useState } from 'react';
import { images } from '../utils/imagePaths';

const Popup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [popupData, setPopupData] = useState({
    title: '',
    description: '',
    image: '',
    video: ''
  });

  const closePopup = () => {
    setIsOpen(false);
    setPopupData({
      title: '',
      description: '',
      image: '',
      video: ''
    });
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="popup">
        <div className="popup-header">
          <span className="close-btn" onClick={closePopup}>
            <img src={images.icons.close} alt="close" />
          </span>
        </div>
        <div className="wrapper">
          <div className="video-img">
            {popupData.video ? (
              <div className="embed-responsive embed-responsive-16by9 popup-video-div">
                <iframe 
                  className="embed-responsive-item popup-video" 
                  src={popupData.video}
                  title={popupData.title}
                  allowFullScreen
                ></iframe>
              </div>
            ) : popupData.image ? (
              <img className="img-fluid popup-image" src={popupData.image} alt={popupData.title} />
            ) : null}
          </div>
          <div className="details">
            <h2 className="popup-title">{popupData.title}</h2>
            <p className="popup-description">{popupData.description}</p>
          </div>
        </div>
      </div>
      <div className="popup-shadow" onClick={closePopup}></div>
    </>
  );
};

export default Popup;